module.exports = __webpack_public_path__ + "static/media/ac-img.47b34c15.jpg";